export default function WhyProgramsWork() {
  const cards = [
    {
      icon: 'ri-search-eye-line',
      title: 'Глубокая диагностика',
      desc: 'До тренинга изучаются звонки, CRM, переписки, интервьюируются сотрудники и руководители. Только после этого формируется программа. Никаких шаблонов.',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Практика на реальных переговорах',
      desc: 'Все упражнения строятся на реальных сделках компании. Разбираются текущие клиенты, настоящие возражения и рабочие ситуации.',
    },
    {
      icon: 'ri-user-voice-line',
      title: 'Работа в поле',
      desc: 'При необходимости участвую в реальных переговорах, совместных встречах с ключевыми клиентами и сложных продажах вместе с менеджерами.',
    },
    {
      icon: 'ri-chat-check-line',
      title: 'Сопровождение после тренинга',
      desc: 'Обучение не заканчивается тренингом. Продолжаем внедрение: разбираем новые переговоры, поддерживаем команду, корректируем стратегию.',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Системный подход',
      desc: 'После проекта остаются: регламенты работы с ЛПР, алгоритмы переговоров, скрипты для разных сценариев, Книга продаж и стандарты компании.',
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      title: 'Измеримые результаты',
      desc: 'Фиксируем исходные показатели до тренинга и отслеживаем динамику: конверсия, средний чек, маржинальность, скорость сделки.',
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-shield-check-line"></i>
            Не стандартные тренинги
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему наши программы работают
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Мы строим обучение иначе. Не просто проводим семинар — а сопровождаем внедрение изменений на каждом этапе.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mb-16">
          {cards.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 md:p-6 hover:bg-teal-50/50 transition-colors group border border-transparent hover:border-teal-100">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-16 h-16 bg-white/15 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <i className="ri-focus-2-line text-3xl text-white"></i>
          </div>
          <p className="text-xl md:text-2xl font-bold text-white leading-relaxed">
            Я остаюсь «играющим тренером». Продолжаю лично продавать свои услуги, консультировать собственников и сопровождать сложные сделки. Поэтому обучаю не теории, а современной практике B2B продаж.
          </p>
        </div>
      </div>
    </section>
  );
}